<template>
    <div class="comment-form-section"
         :class="formOpenClass"
         v-if="componentReady"

    >
        <div class="mentions-form-section" v-if="isUserLoggedIn() && showMentions">
            <div class="mentions-form-window">
                <span class="loader"></span>
                <ul>
                    <li v-for="mention in mentionsList" :key="mention.id">
                        <button @click="replaceMention(mention)">{{ mention.name }}</button>
                    </li>
                </ul>
            </div>
        </div>
        <form action="" class="comment-form" @submit.prevent="submitComment">

            <input type="hidden" name="user-id" v-model="newComment.userId">
            <input type="hidden" name="post-type" v-model="newComment.postType">
            <input type="hidden" name="post-id" v-model="newComment.postId">
            <input type="hidden" name="comment-parent-id" :value="newComment.commentParentId">

            <label :for="formCommentFieldId">Laisse ton commentaire</label>

            <textarea name="user-comment"
                      :id="formCommentFieldId"
                      ref="userCommentField"
                      v-model="newComment.commentText"
                      maxlength="1000"
                      :placeholder="props.placeholder ?? ''"
            ></textarea>

            <p v-if="submissionError" class="comment-submit-error" role="alert">{{ submissionError }}</p>

            <button type="submit"
                    class="btn btn-comment-reply"
                    :class="btnSendClass"
                    ref="btnCommentSubmit"
                    :disabled="cannotSendComment"
            ><span class="ajax-loader on-the-left"></span>
                <span class="text">Envoyer</span>
            </button>
        </form>
    </div>
</template>

<script setup>

import {
    computed,
    onMounted,
    ref,
    reactive,
    watch,
}                   from 'vue';
import { uniqueId } from 'lodash-es';
import axios        from "axios";
import {
    isSessionLoggedIn,
    smoothScrollTo,
}                   from '../composables';
import {
    getCsrfCookie,
    isUserLoggedIn,
    isUserProf,
}                   from '../../Utils';

import { debounce } from 'lodash-es/function.js';

import { useStore } from "vuex";
import { DateTime } from 'luxon';

let store    = useStore();
let copydeck = computed( () => store.state.copydeck );


let componentReady     = ref( false );
let textValue          = ref( '' );
let userCommentField   = ref( null );
let btnCommentSubmit   = ref( null );
let formCommentFieldId = 'user-comment-' + uniqueId();

let props = defineProps( [
    "formOpenClass",
    "commentData",
    "topLevelComment",
    "commentLevel",
    "commentParentId",
    "placeholder",

] );

let emits = defineEmits( [ 'fermemoi', 'tgif' ] );

let postType = computed( () => store.getters.mainContentType ?? 'posts' );
let postId   = computed( () => store.getters.mainContentId ?? 0 );

let currentUser   = computed( () => store.getters.currentUser );
let currentUserId = computed( () => store.getters.currentUserId );

let newComment = reactive( {
    userId          : currentUserId,
    postType        : postType,
    postId          : postId,
    commentParentId : props.commentParentId,
    commentText     : '',
    rootPostType    : '',
    rootId          : '',
} );

let showMentions     = ref( false );
let mentionUser      = ref( '' );
let mentionIndex     = ref( -1 );
let mentionsList     = ref( [] );
let mentionsCount    = ref( 0 );
let mentionUsers     = ref( [] );
let isSendingComment = ref( false )
let submissionError   = ref( '' );

let getMentionListDebounced = debounce( async ( partial ) =>
{
    let audience       = store.getters.audienceMode;
    let response       = await axios.post( `/endpoints/autocomplete/users`, { partial, audience } );
    mentionsList.value = response.data;
}, 300 );

async function getMentionList ( partial )
{
    let audience = store.getters.audienceMode;

    getMentionListDebounced( partial );
}

function replaceMention ( mention )
{
    let commentText = newComment.commentText;

    //replace text between mentionIndex.value and mentionUser.value.length with mention.name

    let newCommentText = commentText.slice( 0, mentionIndex.value ) + "@" + mention.name + "" + commentText.slice( mentionIndex.value + mentionUser.value.length + 1 );

    mentionUsers.value.push( mention.name );
    console.log( newCommentText );

    newComment.commentText = newCommentText;
    showMentions.value     = false;

    userCommentField.value.focus();
}

function getTextBetweenAtAndCursor ( textarea )
{
    // Get the current cursor position
    const cursorPosition = textarea.selectionStart;

    console.log( "cursorPosition", cursorPosition );

    // Get the text from the start to the cursor position
    const textToCursor = textarea.value.substring( 0, cursorPosition );

    console.log( "textToCursor", textToCursor )

    // Find the last '@' character
    const lastAtPosition = textToCursor.lastIndexOf( '@' );

    console.log( "lastAtPosition", lastAtPosition )

    // Get the text between the last '@' and the cursor position
    const textBetween = textToCursor.substring( lastAtPosition + 1 );

    console.log( "textBetween", textBetween )

    return textBetween;
}

watch( newComment, ( newVal, oldVal ) =>
{
    let lastChar = newVal.commentText.slice( -1 );

    //last char is an @
    if ( !showMentions.value && lastChar === "@" )
    {
        showMentions.value = true;
        mentionIndex.value = newVal.commentText.length - 1;
        mentionsList.value = [];
    } else if ( showMentions.value )
    {
        let mention = newVal.commentText.slice( mentionIndex.value );
        // let mention = newVal.commentText;

        //on veut détecter tout ce qui est après le dernier @ jusqu'à ce qu'on trouve un demi espace
        //let mentionMatch = mention.match( /@([^|\s]+[^|]*)(?=\u2005|\s|$)/i );
        //let mentionMatch = mention.match( /@([a-záéíóúüñàèìòùâêîôûäëïöüç0-9\-\s\#\\\/]+)(?![^ ]*\u2005)/i );

        //we want to detect text between the cursor and the previous @
        let strUsername = getTextBetweenAtAndCursor( userCommentField.value );


        // if ( mentionMatch )
        // {
        //     mentionUser.value = mentionMatch[ 1 ];
        //     getMentionList( mentionUser.value );
        // }
        if ( strUsername.length > 0 )
        {
            mentionUser.value = strUsername;
            getMentionList( mentionUser.value );
        } else if ( lastChar === "@" )
        {
            mentionUser.value  = ''
            mentionsList.value = [];
        } else
        {
            showMentions.value = false;
            mentionUser.value  = '';
        }

    }
} )


let btnSendClass = computed( () => isSendingComment.value ? 'ajaxing' : '' );

let isCommentTextEmpty = computed( () => (newComment?.commentText ?? '').length < 1 );
let cannotSendComment  = computed( () => isCommentTextEmpty.value || isSendingComment.value );

// let noUserText = computed( () =>
// {
//     if ( !componentReady )
//     {
//         return true;
//     }
//
//
//     const returnVal = userCommentField.value.commentText.length < 1 || isSendingComment;
//     // console.log( 'noUserText', returnVal );
//
//     return returnVal;
// } );


function getCommentText ()
{
    textValue = ref( userCommentField ).value?.value;
}

function mounted ()
{
    console.log( "%c comment form mounted", "background-color: blue" );
    componentReady.value = true;
}

onMounted( mounted );

function checkIfCanSubmit ()
{

    let userLoggedIn = isUserLoggedIn();


    if ( isUserProf() && "jeunes" === store.getters.audienceMode )
    {
        const triggerEvent = new Event( 'openExplanationProfs' );
        window.dispatchEvent( triggerEvent );
        return false;

    } else if ( userLoggedIn && !isUserProf() && "profs" === store.getters.audienceMode )
    {
        const triggerEvent = new Event( 'openExplanationJeunesActionProfsSeulement' );
        window.dispatchEvent( triggerEvent );
        return false;

    } else if ( !userLoggedIn )
    {

        if ( "profs" === store.getters.audienceMode )
        {
            const event = new Event( 'openExplanationProfsSeulement' );
            window.dispatchEvent( event );
            return false;

        } else
        {
            const event = new Event( 'openExplanationJeunes' );
            window.dispatchEvent( event );

            return false;
        }


    }

    if ( newComment.commentText.length == 0 )
    {
        return false;
    }

    return true;
}

function replaceLocalMention ( comment )
{
    const commentWithMentions = comment.replace( /@[^|]+\|/g, match =>
    {
        const username = match.slice( 0, -1 ); // Remove the trailing '|'
        return `<span class="username">${username}</span>`;
    } );

    return commentWithMentions;
}

async function submitComment ( e )
{

    const canSubmit = checkIfCanSubmit();

    if ( !canSubmit )
    {
        return;
    }

    isSendingComment.value = true;
    submissionError.value = '';
    const originalCommentText = newComment.commentText;
    let optimisticComment = null;

    try
    {

        //let token      = getCsrfCookie();

        let strComment = newComment.commentText;

        //unique list of users mentioned
        mentionUsers.value = [ ...new Set( mentionUsers.value ) ];

        for ( let i = 0; i < mentionUsers.value.length; i++ )
        {
            let user = mentionUsers.value[ i ];

            let escapedUser = user.replace( /[-\/\\^$.*+?()[\]{}|]/g, '\\$&' );

            let regex = new RegExp( `@${escapedUser}`, 'g' );

            strComment = strComment.replace( regex, `@${user}|` );
        }

        mentionUsers.value = [];


        newComment.comment = strComment;

        let now = new Date().getTime();

        let instaComment = { ...newComment };
        optimisticComment = instaComment;

        instaComment.id_comment_parent = instaComment.commentParentId ?? 0;
        instaComment.localDate         = parseInt( now / 1000 );
        instaComment.dateCreatedIso    = DateTime.now().toISO();
        //let dataNewComments = response.data;
        instaComment.user              = currentUser.value;
        instaComment.newId             = now + "-" + Math.round( Math.random() * 10000 );
        instaComment.comment           = replaceLocalMention( instaComment.comment );

        store.commit( "addNewComments", instaComment );


        let sentComment   = { ...newComment };
        sentComment.newId = instaComment.newId;

        newComment.commentText = '';

        const response = await axios.post( '/endpoints/comments',
            sentComment,
            {
                withCredentials : true,
                // headers         : {
                //     'X-CSRF-TOKEN' : token,cd cd
                // },
            } );

        instaComment.id = response.data.id;
        //IF not auto-refreshing comments we  refresh the comments
        if ( !store.state.doLiveRefresh )
        {
            await store.dispatch( "updateRelatedDataInStore" );
        }


        emits( 'fermemoi' );


        scrollToNew( response.data.id, response.data.id_comment_parent );
    }
    catch (error)
    {

        if ( optimisticComment?.newId )
        {
            store.commit( 'removeOptimisticComment', optimisticComment.newId );
        }
        newComment.commentText = originalCommentText;
        submissionError.value = error?.response?.data?.message || 'Impossible de publier le commentaire.';

        console.error( '[CommentForm.vue:submitComment] There was an error', error );
        if ( error.response )
        {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            ////console.log('submitLogin', error.response.data);
            ////console.log('submitLogin', error.response.status);
            ////console.log('submitLogin', error.response.headers);

            // this.formErrors = error.response.data.errors;
            // window.scrollTo( {
            //     top      : this.getElementOffset( '.form-section-register' ).top,
            //     left     : 0,
            //     behavior : 'smooth',
            // } );

        } else if ( error.request )
        {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            ////console.log(error.request);
        } else
        {
            // Something happened in setting up the request that triggered an Error
            ////console.log('Error', error.message);
        }
    }

    isSendingComment.value = false;

}

function highlightNewComment ( commentId, parentCommentId )
{
    console.log( 'highlightNewComment', commentId, parentCommentId );
    if ( !commentId )
    {
        return;
    }

    const maybeCommentElement = document.querySelector( '.comment[data-comment-id="' + commentId + '"]' );

    console.log( 'highlightNewComment:maybeCommentElement', maybeCommentElement );
    if ( !maybeCommentElement )
    {
        return;
    }


    if ( parentCommentId )
    {

        const parent = maybeCommentElement.closest( '.comment-level_1' );

        if ( parent )
        {
            const childrenSection = parent.querySelector( '.child-comments' );

            childrenSection.classList.add( 'children-open' );
        }

        console.log( 'highlightNewComment:parent', parent );

    }


    smoothScrollTo( maybeCommentElement, -150 );
    maybeCommentElement.classList.add( 'flashing-comment' );

    setTimeout( () =>
    {
        maybeCommentElement.classList.remove( 'flashing-comment' );
    }, 3000 );
}

function scrollToNew ( commentId, parentCommentId )
{


    console.log( 'Scrolltonew', commentId );


    // let's bring them to it
    setTimeout( () =>
    {
        highlightNewComment( commentId, parentCommentId );
    }, 500 );
}
</script>

<style scoped>

.comment-submit-error {
    margin: 8px 0 0;
    padding-left: 8px;
    color: #b91c1c;
    font-size: 14px;
    line-height: 1.4;
}

</style>
